module.exports = __webpack_public_path__ + "static/img/ranking-icon.c1fa9f1b.png";